import axios from 'axios';
import { getAccessToken, getIsApiPending } from '../../../selectors/digitalSavings/payment';
import { apiTransitionPayloadCollection } from '../../../actions/digitalSavings/payloadCollection';
import { getQuoteId } from '../../../selectors/digitalSavings/personalDetails';
import { apiTransitionPaymentsStatus } from '../../../actions/digitalSavings/payment';

export const savePayments = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPaymentsStatus.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionPaymentsStatus.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPaymentsStatus.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const qid = getQuoteId(state);

    const payload = {
        quoteId: qid || 0,
        paymentMethod: 'Bank',
        paymentTermsAcceptanceStatus: true,
        mpesaPaymentNumber: null,
        bankPaymentAccountNumber: null,
        paymentReference: null,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/digital-savings/new-payments';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};

export const saveFailedPayments = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                await makeSubmission(store.getState());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};
